module.exports = __webpack_public_path__ + "static/media/TC01@l.a51de737.jpg";